export default __webpack_public_path__ + "static/media/card-image8.734f6da8.png";